import { useState, useCallback, createContext, useMemo } from 'react';
import { isNotDefined, listToMap, isFalsyString, caseInsensitiveSubmatch } from '@togglecorp/fujs';

function useFilterState(defaultValue) {
  const [filtering, setFiltering] = useState(defaultValue);
  const setFilteringItem = useCallback((id, value) => {
    setFiltering(function () {
      let oldFiltering = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const index = oldFiltering.findIndex(item => item.id === id);

      if (isNotDefined(value)) {
        const newFiltering = [...oldFiltering];

        if (index === -1) {
          console.error('There is some error');
        } else {
          newFiltering.splice(index, 1);
        }

        return newFiltering;
      }

      const newValue = { ...value,
        id
      };
      const newFiltering = [...oldFiltering];

      if (index === -1) {
        newFiltering.push(newValue);
      } else {
        newFiltering.splice(index, 1, newValue);
      }

      return newFiltering;
    });
  }, []);
  const getFilteringItem = useCallback(id => {
    if (!filtering) {
      return undefined;
    }

    return filtering.find(item => item.id === id);
  }, [filtering]);
  return {
    filtering,
    setFiltering,
    setFilteringItem,
    getFilteringItem
  };
}
const initialValue = {
  filtering: undefined,
  setFiltering: state => {
    console.warn('Trying to set to ', state);
  },
  setFilteringItem: (id, state) => {
    console.warn(`Trying to set ${id} to `, state);
  },
  getFilteringItem: () => undefined
};
const FilterContext = /*#__PURE__*/createContext(initialValue);
function useFiltering(filterParameters, columns, data) {
  const filteredData = useMemo(() => {
    if (!filterParameters || filterParameters.length <= 0) {
      return data;
    }

    const columnsMapping = listToMap(columns, column => column.id, column => column);
    return data === null || data === void 0 ? void 0 : data.filter(datum => filterParameters.every(filterParameter => {
      let test = true;
      const {
        id,
        subMatch,
        greaterThanOrEqualTo,
        lessThanOrEqualTo
      } = filterParameter; // Identify if filtering is applied

      if (isNotDefined(greaterThanOrEqualTo) && isNotDefined(lessThanOrEqualTo) && isNotDefined(subMatch)) {
        return true;
      } // Filter out if we dont't have a column.valueSelector


      const column = columnsMapping[id];

      if (!(column !== null && column !== void 0 && column.valueSelector)) {
        return false;
      } // Filter out if value is undefined


      const val = column.valueSelector(datum);

      if (isNotDefined(val)) {
        return false;
      }

      if (typeof val === 'string') {
        test = isFalsyString(subMatch) || caseInsensitiveSubmatch(val, subMatch);
      } else {
        test = (isNotDefined(greaterThanOrEqualTo) || val >= greaterThanOrEqualTo) && (isNotDefined(lessThanOrEqualTo) || val <= lessThanOrEqualTo);
      }

      return test;
    }));
  }, [columns, data, filterParameters]);
  return filteredData;
}

export { FilterContext, useFiltering as default, useFilterState, useFiltering };
//# sourceMappingURL=useFiltering.js.map
